import React, { useEffect, useState } from 'react';
import lottie from 'lottie-web';
import straightToArrow from '../../../../json/splashverse-onboarding/back-btn-str-arr.json';
import arrowToStraight from '../../../../json/splashverse-onboarding/back-btn-arr-str.json';
import Loading from '../../../../json/splashverse-onboarding/back-btn-loading.json';
import { useDispatch, useSelector, shallowEqual} from 'react-redux'
import { resetSVOnboardingEventParam } from '../../../stores/splashverse-onboarding/actions';

import { sendEventUsingAvo } from '../../../utils/web-helper';
import UsePrevious from '../../common/hooks/usePreviousValue';
import * as S from './style';

const BackToPreviousStepButton = ({...props}) => {

  const prevIndex = UsePrevious(props.currentStepIndex);
  const [backbuttonState, setBackButtonState] = useState('flat');

  const {isBackButtonLoading, svOnboardingEventParams, selectedGrade, selectedSubject} = useSelector(state => { 
    return {
      isBackButtonLoading: state.isBackButtonLoading,  
      svOnboardingEventParams: state.svOnboardingEventParams,
      selectedSubject: state.selectedSubject,
      selectedGrade: state.selectedGrade,
    }
  }, shallowEqual);

  const dispatch = useDispatch();

  // event tracking function for back button;
  const trackBackButtonInteracted = () => {
    let globalProp = {
      Platform: 'Web',
      'Clicked On': 'Back'
    }
    if(window.location.href.indexOf("age-select")>-1){
        let params = {
          clickedOn: 'Back'
        }
        sendEventUsingAvo({methodName: 'ageQuestionScreenInteracted',params});
    }
    if (selectedGrade && selectedSubject) {
      globalProp = { 
        ...globalProp,
        Subject: selectedSubject,
        Grade: selectedGrade,
      }
    }
    if(svOnboardingEventParams) {
      const name = svOnboardingEventParams.interactedFrom;
      if (name) {
        const params = svOnboardingEventParams.params;
        trackAnalyticsEvent(name, {...globalProp, ...params});
      }
      dispatch(resetSVOnboardingEventParam());
    }
  }

  const onBackButtonClick = () => {
    trackBackButtonInteracted();
    props.goBackHandler();
  }

  useEffect(() => {
    if (typeof(prevIndex) == 'undefined') changeBackButtonState(false, true, false);
    if ((props.currentStepIndex > prevIndex && backbuttonState !== 'arrow') || backbuttonState === 'loading') changeBackButtonState(false, true, false);
    if (props.currentStepIndex === 0) changeBackButtonState(true, false, false);
    if (isBackButtonLoading) changeBackButtonState(false, false, true);
  }, [props.currentStepIndex, isBackButtonLoading])

  const changeBackButtonState = (flat, arrow, isLoading) => {
    let animationData = null;
    let loop = false;
    if (flat) {
      animationData = arrowToStraight;
      setBackButtonState('flat');
    }
    if (arrow) {
      animationData = straightToArrow;
      setBackButtonState('arrow');
    }
    if (isLoading) {
      animationData = Loading;
      loop = true;
      setBackButtonState('loading');
    }
    
    if (animationData) {
      lottie.destroy('back-btn');
      lottie.loadAnimation({
        container: document.getElementById('button-animate'),
        renderer: 'svg',
        loop: loop,
        autoplay: true,
        animationData: animationData,
        name: 'back-btn',
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      });
    }
  }

  return (
    <S.BackButtonContainer className="back-btn-container">
      <S.Button id='back-button-sv' isFlat={backbuttonState==='flat'}>
        <S.AnimationContainer id='button-animate' clickDisable={backbuttonState === 'loading'} onClick={onBackButtonClick}/>
      </S.Button>
    </S.BackButtonContainer>
  )
}

export default BackToPreviousStepButton;